import React, { createContext, useContext, useEffect, useState } from "react";
import { logoutAdmin } from "../core/services/authService";

const AuthContext = createContext<any>(null);

export const AuthProvider = ({ children }: any) => {
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("adminToken"),
  );

  // Whenever the API client hits a 401 it clears localStorage and fires this
  // event. We mirror that here so React state (and every route guarded by
  // useAuth) reacts immediately instead of only after a manual page refresh.
  useEffect(() => {
    const handleUnauthorized = () => setToken(null);

    window.addEventListener("auth:unauthorized", handleUnauthorized);

    return () =>
      window.removeEventListener("auth:unauthorized", handleUnauthorized);
  }, []);

  const logout = async () => {
    try {
      await logoutAdmin();
    } catch {
      // Local logout should still proceed even if the server call fails
      // (e.g. session already expired on the backend).
    } finally {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminProfile");
      setToken(null);
    }
  };

  return (
    <AuthContext.Provider value={{ token, setToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
